import { css } from "lit-element";

export const styles = css`
	:host {
	margin-bottom: 5.5rem;
}

	.single-post {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		overflow: hidden;
		position: relative;
		container-name: single-post;
		box-sizing: border-box;
		gap: 1.5rem;
	}

	.full-post {
		flex-direction: row;
	}

	.full-post img {
		height: 28rem;
		}

	.img-container {
		width: 100%;
		height: 100%;
		position: relative;
		border-radius: 0.3125rem;
		overflow: hidden;
	}

	.loading {
		background-color: #f4f4f4;
		border-radius: 1.875rem;
		height: 100%;
		width: 100%;
		display: block;
		position: relative;
	}

	img {
		border-radius: 0.3125rem;
		overflow: visible;
		overflow-clip-margin: unset;
		object-fit: cover;
		height: 14rem;
		width: 100%;
	}

	.single-post .content-container {
		width: 100%;
	}

	.single-post span {
	  color: var(--e-global-color-accent);
		font-size: 1rem;
	}

	.single-post h2 {
		color: #F53D73;
		font-size: 1.25rem;
		font-weight: 700;
		text-transform: uppercase;
		min-height: 55px;
	}

	.single-post p {
		color: #310210;
		font-size: 1rem;
		font-weight: 300;
		min-height: 250px;
	}

	.single-post a {
		border-radius: 4rem;
		background: linear-gradient(0deg, #F53D73 0%, #F53D73 100%), rgba(253, 231, 238, 0.00);
		color: #FDE7EE;
		text-align: center;
		font-size: 1rem;
		font-style: normal;
		text-decoration: none;
		font-weight: 400;
		padding: 0.5rem 3rem;
		display: inline-block;
	}

	.single-post a:hover {
		background: linear-gradient(0deg, #C42755 0%, #C42755 100%), rgba(253, 231, 238, 0.20);
	}

	h2 {
		font-size: 1.75rem;
		font-style: normal;
		font-weight: 400;
		line-height: 120%; /* 2.1rem */
		font-family: var(--headings-font-family);
		margin: 0;
	}

	@media screen and (max-width: 1030px) {

		.single-post {
			flex-direction: column;
			padding: 1rem;
			width: 100%;
		}

		.single-post h2 {
			font-size: 1.75rem;
	
		}

		.single-post p {
			font-size: 1rem;
			line-break: auto;
			min-height: unset;
			font-weight: 300;
		}

		.single-post a {
			font-size: 1.25rem;
		}

		.single-post img { 
			height: 30rem;
			object-position: center center;
}

			:host {
	margin-bottom: 3rem;
}
	}
}`;
